import { z } from 'zod';

export const UF_VALUES = [
  'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO',
  'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR',
  'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO',
] as const;

export type UF = (typeof UF_VALUES)[number];

/** Schema Zod completo para endereço brasileiro */
export const addressSchema = z.object({
  zip: z.string().regex(/^\d{8}$/, 'CEP deve ter 8 dígitos'),
  street: z.string().min(1).max(200),
  number: z.string().min(1).max(20),
  complement: z.string().max(100).optional(),
  neighborhood: z.string().min(1).max(100),
  city: z.string().min(1).max(100),
  state: z.enum(UF_VALUES),
});

/** Versão com todos os campos opcionais (para PATCH / update parcial) */
export const addressPatchSchema = addressSchema.partial();

export type Address = z.infer<typeof addressSchema>;
export type AddressPatch = z.infer<typeof addressPatchSchema>;

/** Formata endereço estruturado em string de uma linha */
export function formatAddress(addr: { zip?: string; street?: string; number?: string; complement?: string; neighborhood?: string; city?: string; state?: string }): string {
  const parts: string[] = [];
  if (addr.street) {
    let line = addr.street;
    if (addr.number) line += `, ${addr.number}`;
    if (addr.complement) line += ` - ${addr.complement}`;
    parts.push(line);
  }
  if (addr.neighborhood) parts.push(addr.neighborhood);
  if (addr.city && addr.state) {
    parts.push(`${addr.city}/${addr.state}`);
  } else if (addr.city) {
    parts.push(addr.city);
  }
  if (addr.zip) {
    parts.push(addr.zip.replace(/^(\d{5})(\d{3})$/, '$1-$2'));
  }
  return parts.join(', ');
}
